export enum ETipoPlanoConta {
    Financeiro = 1,
    Contabil = 2,
    Outros = 3,
}
